<script setup lang="ts">
import { computed, watch } from 'vue';
import { useStore } from '#imports';

const selectedRoleId = defineModel<string | undefined>({ default: undefined });

const store = useStore();
const { data: orgRoles, loading: orgRolesLoading } = store.MonospaceOrgRole.query((q) => q.many());

const orgRoleOptions = computed(() =>
	(orgRoles.value ?? []).map((role) => ({ label: role.name, value: role.id })),
);

// Pick a sensible default once roles arrive: the first non-admin role, falling back to the first role.
watch(orgRoles, (roles) => {
	if (selectedRoleId.value || !roles?.length) return;
	selectedRoleId.value = (roles.find((role) => !role.isAdmin) ?? roles[0])?.id;
}, { immediate: true });
</script>

<template>
	<DSelect
		v-model="selectedRoleId"
		:items="orgRoleOptions"
		value-key="value"
		label-key="label"
		:placeholder="$t('invites.org_role_placeholder')"
		:disabled="orgRolesLoading"
	/>
</template>
